import { useLayoutEffect, useRef, useState } from "react";
import { leadsMatchTable, tableMenuItems } from "../../adminData";
import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import GlobalTableDropDown from "../../GlobalTableDropDown";
import {
  formatDate,
  formatPhoneNumber,
  formatTime,
} from "../../../../../utilities/utils";
import Loader from "../../../../commons/Loader";
import Pagination from "../../../pagination";
import { useNavigate } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const LeadsMatchesTable = ({ leadsData, getUpdateData }) => {
  const checkbox = useRef();
  const navigate = useNavigate()
  const [checked, setChecked] = useState(false);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [showMenu, setShowMenu] = useState(null);

  const { data, meta } = leadsData ?? {};
  const { current_page, last_page, per_page } = meta ?? {};

  function toggleAll() {
    setSelectedPeople(checked ? [] : data);
    setChecked(!checked);
  }

  const handleMenuItems = (userId, flag) => {
    if (!flag) {
      setShowMenu(userId.id);
    } else {
      setShowMenu(null);
    }
  };

  const handleLeadsNavigation = (lead) => {
    navigate(`/admin-dashboard/unmatched/${lead.id}`, {
      state: {
        matchInfo: lead,
      },
    });
  };

  return (
    <>
      <div className="px-4 sm:px-6 lg:px-8 hidden md:block">
        {!data ? (
          <Loader isLoading={true} />
        ) : (
          <div className="mt-8 flow-root">
            <div className="table-scroller -mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 bg-white border border-[#EBEFF3] rounded-md p-5">
              <div className="inline-block min-w-full py-2 align-middle">
                <div className="relative">
                  <table className="min-w-full table-fixed divide-y divide-gray-300">
                    <thead>
                      <tr>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Name
                        </th>
                        <th
                          scope="col"
                          className="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-bold text-[#485868]"
                        >
                          Profession
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Phone Number
                        </th>
                        <th
                          scope="col"
                          className="px-3 py-3.5 text-left text-sm font-bold text-[#485868]"
                        >
                          Created at
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {data &&
                        data.map((lead, index) => (
                          <tr
                            key={lead.email}
                            onClick={() => handleLeadsNavigation(lead)}
                            className="cursor-pointer hover:bg-[#EBF7FF]"
                          >
                            <td
                              className={classNames(
                                "whitespace-nowrap py-4 pr-3 text-sm font-normal",
                                selectedPeople.includes(lead)
                                  ? "text-primary"
                                  : "text-customGray"
                              )}
                            >
                              {lead.first_name.concat(
                                " ",
                                lead.last_name ?? ""
                              ) ?? ""}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {lead.profession?.name}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatPhoneNumber(lead.phone_number)}
                            </td>
                            <td className="whitespace-nowrap px-3 py-4 text-sm text-customGray">
                              {formatDate(lead.created_at)} &#8226;{" "}
                              {formatTime(lead.created_at)}
                            </td>
                            {/* <td>
                              <GlobalTableDropDown
                                data={lead}
                                showMenu={showMenu == lead.id}
                                callBack={handleMenuItems}
                                isLastIndex={index == data.length - 2}
                                menuItems={tableMenuItems}
                              />
                            </td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {data?.length < 1 && (
                    <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
                      No Record Found.
                    </h4>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="block md:hidden">
        <div>
          <ul>
            {data &&
              data.slice(0, 5).map((lead) => (
                <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Name
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {lead.first_name.concat(" ", lead.last_name)}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Profession
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {lead.profession?.name}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Phone Number
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatPhoneNumber(lead.phone_number)}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created at
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(lead.created_at)} &#8226;{" "}
                        {formatTime(lead.created_at)}
                      </span>
                    </li>
                  </ul>
                  {/* <div>
                    <GlobalTableDropDown
                      data={lead}
                      showMenu={showMenu === lead.id}
                      callBack={handleMenuItems}
                      // isLastIndex={index == leadsMatchTable.length - 2}
                      menuItems={tableMenuItems}
                    />
                  </div> */}
                </li>
              ))}
          </ul>
          {data?.length < 1 && (
            <h4 className="flex items-center justify-center mt-5 text-lg text-primary py-6 font-bold">
              No Record Found.
            </h4>
          )}
        </div>
      </div>
      {data?.length > 0 && (
        <Pagination
          currentPage={current_page}
          totalPages={last_page}
          nextPage={getUpdateData}
          previousPage={getUpdateData}
          directIntoPage={getUpdateData}
          perPageItem={per_page}
          showNumberOfPages={3}
        />
      )}
    </>
  );
};

export default LeadsMatchesTable;
